import whevent from 'whevent';

export const showPopup = (id, popup, props, config) => {
	whevent.emit('$SHOW_POPUP', { id, popup, props, config });
}

export const closePopup = id => {
	whevent.emit('$CLOSE_POPUP', id);
}